<template>
    <div class="faq-item w-full border-b">
        <div class="faq-title flex justify-between items-center cursor-pointer" @click="toggle">
            <h5>{{ title }}</h5>
            <img :class="{ 'rotate': isExpanded }" src="../../../assets/svg/plus-icon.svg" alt="Plus Icon" />
        </div>
        <div v-if="isExpanded" class="faq-description">
            <p>{{ description }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FaqItem',
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isExpanded: false
        };
    },
    methods: {
        toggle() {
            this.isExpanded = !this.isExpanded;
        }
    }
};
</script>

<style lang="scss" scoped src="./FaqItem.scss"></style>
